import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TimepickerComp;

class TimePicker extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: TimepickerComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/timepicker-comp" */
            "../../../components/javascript/zcat-components/timepicker-comp"
        ).then(function(res) {
            TimepickerComp = res.TimepickerComp;
        }));

        
;
    }
}

export {TimePicker};

